import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import AreaMarquee from "@/components/landing/AreaMarquee";
import Services from "@/components/landing/Services";
import BeforeAfter from "@/components/landing/BeforeAfter";
import Reviews from "@/components/landing/Reviews";
import QuoteSection from "@/components/landing/QuoteSection";
import Footer from "@/components/landing/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#0A0A0A] text-white">
      <Navbar />
      <Hero />
      <AreaMarquee />
      <Services />
      <BeforeAfter />
      <Reviews />
      <QuoteSection />
      <Footer />
    </div>
  );
}
